import React, { useEffect, useState } from "react";

import CommunityVisitRules from "./tabs/CommunityVisitRules";
import CommunityVisitRulesModal from "./components/CommunityVisitRulesModal";
import PatientVisitRules from "./tabs/PatientVisitRules";
import PatientVisitRulesModal from "./components/PatientVisitRulesModal";
import SchedulingSettingsHeader from "../../components/SchedulingSettingsHeader";
import classNames from "classnames";
import { selectUser } from "../../../../features/auth/authSlice";
import { useFetchVisitRulesMutation } from "../../../../features/organisation/organisationApiSlice";
import { useSelector } from "react-redux";
import Loading from "../../../../components/Loading";
import useDebounce from "../../../../hooks/useDebounce";

const VisitRules = ({ isWelcomePage, isFileUpload }) => {
  const [tab, setTab] = useState("community");
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [frequencyFilter, setFrequencyFilter] = useState([]);
  const [availabilityFilter, setAvailabilityFilter] = useState([]);
  const [count, setCount] = useState(0);

  const debouncedSearch = useDebounce(search, 500);


  const [communityVisitRules, setCommunityVisitRules] = useState([]);
  const [patientVisitRules, setPatientVisitRules] = useState([]);
  const [opaque, setOpaque] = useState(false);

  const [communityVisitRulesModalOpen, setCommunityVisitRulesModalOpen] =
    useState(false);

  const [patientVisitRulesModalOpen, setPatientVisitRulesModalOpen] =
    useState(false);

  const handleCommunityVisitRulesModal = () => {
    setCommunityVisitRulesModalOpen(!communityVisitRulesModalOpen);
    setOpaque(!opaque);
  };

  const handlePatientVisitRulesModal = () => {
    setPatientVisitRulesModalOpen(!patientVisitRulesModalOpen);
    setOpaque(!opaque);
  };

  const handleTabChange = (tab) => {
    setTab(tab);
    setSearch("");
    setFrequencyFilter([]);
    setAvailabilityFilter([]);
  };

  const [communityConstraintToEdit, setCommunityConstraintToEdit] =
    useState(null);

  const [patientConstraintToEdit, setPatientConstraintToEdit] = useState(null);

  const [fetchVisitRulesAPI, { isLoading }] = useFetchVisitRulesMutation();

  const user = useSelector(selectUser);

  const fetchVisitRules = async (data) => {
    try {
      const response = await fetchVisitRulesAPI({
        orgId: user.organisation.id,
        search: data.search || debouncedSearch,
        frequency: data.frequencyFilter || frequencyFilter,
        availability: data.availabilityFilter || availabilityFilter,
        limit: data.limit || 20,
        skip: data.skip || 0,
        type: tab,
      }).unwrap();
      if (tab === "community") {
        setCommunityVisitRules(response.data);
      } else {
        setPatientVisitRules(response.data);
      }
      setCount(response.count);
    } catch (error) {
      console.error(error.data.message);
    }
  };
  useEffect(() => {
    fetchVisitRules({
      search: debouncedSearch,
      frequencyFilter: frequencyFilter,
      availabilityFilter: availabilityFilter,
      limit: 20,
      skip: 0,
      type: tab,
    });
  }, [isFileUpload, debouncedSearch, frequencyFilter, availabilityFilter, tab]);

  useEffect(() => {
    if (refresh) {
      fetchVisitRules();
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    if (communityConstraintToEdit !== null) {
      handleCommunityVisitRulesModal();
    }
  }, [communityConstraintToEdit]);

  useEffect(() => {
    if (patientConstraintToEdit !== null) {
      handlePatientVisitRulesModal();
    }
  }, [patientConstraintToEdit]);

  useEffect(() => {
    if (!communityVisitRulesModalOpen) {
      setCommunityConstraintToEdit(null);
    }
  }, [communityVisitRulesModalOpen]);

  useEffect(() => {
    if (!patientVisitRulesModalOpen) {
      setPatientConstraintToEdit(null);
    }
  }, [patientVisitRulesModalOpen]);

  return (
    <div
      // className={`relative flex flex-col w-full ${
      //   isWelcomePage ? "" : "h-screen"
      // }`}
      className={`relative flex flex-col w-full  ${isWelcomePage ? "" : "overflow-hidden"
        }`}
    >
      {!isWelcomePage && <SchedulingSettingsHeader title="Visit Rules" />}
      <div
        // className={`w-full px-4 ${isWelcomePage ? "" : "h-screen overflow-hidden"
        //   }`}
        className={`w-full px-4 ${isWelcomePage ? "" : " overflow-hidden"
          }`}
      >
        <div
          className={`flex flex-col items-center gap-4 sm:flex-row ${isWelcomePage ? "mb-4" : "py-4"
            } `}
        >
          {user?.permissions?.includes('visit_rules.view_community_rules') && <button
            className={classNames(
              "px-4 py-2 font-bold rounded-lg sm:w-60 w-full",
              tab === "community"
                ? "bg-primaryblue text-white"
                : "text-gray-900 bg-white border border-gray-300"
            )}
            onClick={() => {
              handleTabChange("community");
            }}
          >
            Community Visit Rules
          </button>}
         {user?.permissions?.includes('visit_rules.view_home_visit_rules') && <button
            className={classNames(
              "px-4 py-2 font-bold rounded-lg sm:w-60 w-full",
              tab === "patient"
                ? "bg-primaryblue text-white"
                : "text-gray-900 bg-white border border-gray-300"
            )}
            onClick={() => {
              handleTabChange("patient");
            }}
          >
            Home Visit Rules
          </button>}
        </div>
        {isLoading && <Loading loading={isLoading} />}
        <div className="w-full border-b-[1px] border-b-secondarygrayborder" />
        {tab === "community" && communityVisitRules !== null && user?.permissions?.includes('visit_rules.view_community_rules') && (
          <CommunityVisitRules
            rules={communityVisitRules}
            handleCommunityVisitRulesModal={handleCommunityVisitRulesModal}
            constraintToEdit={communityConstraintToEdit}
            setConstraintToEdit={setCommunityConstraintToEdit}
            setVisitRules={setCommunityVisitRules}
            isWelcomePage={isWelcomePage}
            count={count}
            fetchConstraints={fetchVisitRules}
            setSearch={setSearch}
            search={search}
            setFrequencyFilter={setFrequencyFilter}
            frequencyFilter={frequencyFilter}
            setAvailabilityFilter={setAvailabilityFilter}
            availabilityFilter={availabilityFilter}
          />
        )}
        {tab === "patient" && patientVisitRules !== null && user?.permissions?.includes('visit_rules.view_home_visit_rules') && (
          <PatientVisitRules
            rules={patientVisitRules}
            handlePatientVisitRulesModal={handlePatientVisitRulesModal}
            constraintToEdit={patientConstraintToEdit}
            setConstraintToEdit={setPatientConstraintToEdit}
            setVisitRules={setPatientVisitRules}
            isWelcomePage={isWelcomePage}
            count={count}
            fetchConstraints={fetchVisitRules}
            setSearch={setSearch}
            search={search}
            setAvailabilityFilter={setAvailabilityFilter}
            availabilityFilter={availabilityFilter}
          />
        )}
        {communityVisitRulesModalOpen && (
          <CommunityVisitRulesModal
            handleCommunityVisitRulesModal={handleCommunityVisitRulesModal}
            setRefresh={setRefresh}
            details={communityConstraintToEdit}
            visitRules={communityVisitRules}
            setVisitRules={setCommunityVisitRules}
          />
        )}
        {patientVisitRulesModalOpen && (
          <PatientVisitRulesModal
            handlePatientVisitRulesModal={handlePatientVisitRulesModal}
            setRefresh={setRefresh}
            details={patientConstraintToEdit}
            visitRules={patientVisitRules}
            setVisitRules={setPatientVisitRules}
          />
        )}
      </div>
    </div>
  );
};

export default VisitRules;
